// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.caseinfo {
  font-family: montserrat !important;
  height: 73vh;
}

.Case_360_view {
  font-size: 12px !important;
}

.insurance_detials {
  font-family: montserrat !important;
}

.quality_attribute {
  font-family: montserrat !important;
}

.eventselecttypeControl {
  width: 96%;
  border: none;
  padding-block: 2px;
  height: 28px;
  margin-left: 2%;
  padding-right: 23px !important;
}

.blod_text {
  color: #007887;
}

.date_control_style {
  width: 30%;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.14), 0 2px 1px -1px rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  padding-inline: 2%;
}

.close_icon {
  position: absolute;
  top: 27%;
  font-size: 16px;
  cursor: pointer;
  color: grey;
  font-weight: 600;
  right: 0;
}

.help-main-title {
  font-size: 17px;
  text-align: center;
}

.case_details {
  flex: auto;
  text-align: center;
  position: relative;
}

.caseHeaderBorder {
  height: 14px;
  width: 2px;
  background-color: #376b96 !important;
  position: absolute;
  top: 14%;
  right: 0%;
}

.case_info {
  background: #c1bdbd 0% 0% no-repeat padding-box;
  padding-inline: 8px;
}

::ng-deep.case_tabs .mat-tab-header {
  height: 33px;
}

.active_img {
  display: none;
}

.inactive_img {
  display: block;
  margin-right: 9px;
  position: relative;
  top: -2px;
}

.active_img_inbound {
  display: none;
}

.inactive_img_inbound {
  display: block;
  margin-right: 11px;
  position: relative;
  top: -2px;
}

::ng-deep.event_card {
  height: 75vh;
  border-right: 3px solid #007887;
}
::ng-deep.event_card .header {
  height: 50px;
  background: #F2F2F2 0% 0% no-repeat padding-box;
}
::ng-deep.event_card .header .search_control {
  width: 90%;
  height: 28px;
  margin: auto;
  border-radius: 5px;
  border: 1px solid #001C3B;
  background-color: white;
}
::ng-deep.event_card .header .search_control .search_icon {
  position: relative;
  left: 2%;
  top: 10%;
}
::ng-deep.event_card .header .search_control .input_control {
  width: 93%;
  border: none;
  background-color: transparent;
  position: relative;
  left: 3%;
  top: 13%;
}
::ng-deep.event_card .mat-tab-label {
  height: 37px !important;
  flex: 1 !important;
  text-transform: uppercase;
}
::ng-deep.event_card .mat-tab-group.mat-primary .mat-ink-bar,
::ng-deep.event_card .mat-tab-nav-bar.mat-primary .mat-ink-bar {
  margin-left: unset !important;
}
::ng-deep.event_card .mat-tab-label-container {
  background-color: #F3F3F3 !important;
}
::ng-deep.event_card .mat-tab-group.mat-primary .mat-ink-bar {
  background-color: #17a0b4 !important;
  height: 3px !important;
}
::ng-deep.event_card .mat-tab-label .mat-tab-label-content {
  font-size: 12px !important;
  font-weight: 600 !important;
  font-family: montserrat !important;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active {
  color: #17a0b4 !important;
  background-color: white !important;
  opacity: unset !important;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .active_img {
  display: block !important;
  margin-right: 9px;
  position: relative;
  top: -2px;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active .outbound_style .inactive_img {
  display: none !important;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .active_img_inbound {
  display: block !important;
  margin-right: 11px;
  position: relative;
  top: -2px;
}
::ng-deep.event_card .mat-tab-label.mat-ripple.mat-tab-label-active .inbound_style .inactive_img_inbound {
  display: none !important;
}

.event_card_info {
  height: 75vh;
  border-left: 3px solid #007887;
  margin-left: 2px;
}
.event_card_info .header {
  height: 50px;
  background: #F2F2F2 0% 0% no-repeat padding-box;
}

.Event_lables {
  height: 60px;
  background: #E5F1F3;
  padding-inline: 13px;
}

.eventtype_lables {
  background-color: white;
  padding-inline: 4%;
  padding-block: 0px;
  margin: 8px;
  display: inline-block;
  border-radius: 50pc;
  cursor: pointer;
  box-shadow: 1px 1px 4px 0px grey;
}

.eventtype_lables_active {
  background-color: #007887;
  padding-inline: 4%;
  padding-block: 0px;
  margin: 8px;
  display: inline-block;
  border-radius: 50pc;
  cursor: pointer;
  color: white;
  box-shadow: 1px 1px 4px 0px grey;
}

.messageInfo {
  border-left: 4px solid green;
  box-shadow: 1px 1px 6px 0px grey;
  border-radius: 5px;
  padding-inline: 6px;
  padding-block: 3px;
}

.cardActive {
  background-color: #CCE4E7;
}

.listview {
  padding-inline: 19px;
  max-height: 53vh;
  overflow-x: hidden;
  overflow-y: auto;
}

.view_file_icon {
  width: 19px !important;
  float: left;
  position: relative;
  top: -3px;
  left: 6px;
}

.barline {
  height: 1px;
  background-color: black;
  margin-inline: 13px;
}

::ng-deep.message_menu.mat-menu-panel button.mat-menu-item {
  height: 26px !important;
  line-height: 26px !important;
  text-align: center !important;
  color: #179fb3 !important;
  font-size: 13px !important;
}

.lables_status {
  border-radius: 4px;
  padding-block: 3px;
  font-size: 10px;
  font-weight: 600;
}

::ng-deep.viewstages .modal-dialog {
  max-width: 97% !important;
  max-height: 60% !important;
  height: 60% !important;
  margin: auto !important;
  padding: 0 !important;
}

::ng-deep.viewstages {
  top: 4% !important;
}

.inputContainer {
  height: 81vh;
  background-color: #F3F3F3;
  border: 1px solid #707070;
}
.inputContainer .header {
  background-color: #D1D1D1;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #707070;
}

.outputContainer {
  height: 81vh;
  background-color: #F3F3F3;
  border: 1px solid #707070;
}
.outputContainer .header {
  background-color: #D1D1D1;
  font-size: 12px;
  font-weight: 500;
  border-bottom: 1px solid #707070;
}

.icons_list_style {
  width: 5%;
  padding-bottom: 8px;
  text-align: center;
  margin-inline: 3px;
}

.icons_list_style_active {
  border-bottom: 3px solid #00BCD4;
  width: 5%;
  padding-bottom: 8px;
  text-align: center;
  margin-inline: 3px;
}

.case_info_container {
  border: 1.5px solid #001C3B;
  padding: 5px;
  position: relative;
  margin-block: 16px;
}

.sign_out_details {
  border: 1.5px solid #001C3B;
  padding: 5px;
  position: relative;
  margin-block: 16px;
  height: 44vh;
}

.card_label_title {
  background-color: #fbfbfb;
  position: absolute;
  padding-inline: 5px;
  font-size: 10px;
  top: -9px;
  color: #001C3B;
  font-weight: 600;
}

.lables_style {
  font-size: 10px;
  color: #001C3B;
  font-weight: 600;
}

.value_style {
  font-weight: 600;
  font-size: 10px;
  color: #5682A6 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.case_details_info {
  height: 16.5vh;
}

.dates_info {
  height: 22vh;
}

.case_info_data {
  height: 28vh;
}

.case_patient_info {
  height: 35vh;
}

.case_Information_info {
  height: 29vh;
}

.case_Contact_info {
  height: 29vh;
}

.case_Insurance_info {
  height: 17vh;
}

.case_DX_reports {
  min-height: 12vh;
  margin-bottom: 20px;
}

.report-name {
  margin-right: 30px;
  max-width: 125px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  font-weight: bold;
}

.report_status {
  white-space: normal;
  overflow: visible;
  word-break: normal;
}

.case_send_in_details {
  height: 12vh;
}

.case_referring_details {
  height: 14vh;
}

.case_laboratory_details {
  height: 20vh;
}

.case_orderingfacility_details {
  height: 17vh;
}

.case_send_out_details {
  height: 11vh;
}

.sec_date {
  font-size: 10px;
}

.pt_date {
  font-size: 9px;
  margin-left: 3px;
}

.more_info {
  color: rgba(0, 0, 255, 0.6509803922);
  text-decoration: underline;
  cursor: pointer;
}

.orderedDate {
  color: #827EC4 !important;
}

.collectionDate {
  color: #80A8D0 !important;
}

.receivedDate {
  color: #278C7D !important;
}

.signedoutDate {
  color: #D17800 !important;
}

.reportDate {
  color: #C02755 !important;
}

.sendinDate {
  color: #443EA7 !important;
}

.sendoutDate {
  color: #3575B5 !important;
}

.insurance_more_info {
  height: 59.5vh;
}

.text_elip {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.flag_class {
  background-color: #E8E8E5;
  border-radius: 3px;
  color: #001C3B;
  font-size: 11px;
  min-width: 164px !important;
  padding-inline: 9px;
  margin-inline: 3px;
  max-width: 320px;
  height: 23px;
  display: inline-block;
  justify-content: center;
  align-items: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
  padding-block: 3px;
}

.no_data {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #17a0b4;
}

.myCustomModalViewfile .modal-dialog {
  max-width: 80%;
  max-height: 60%;
  height: 60%;
  margin: auto;
  padding: 0 !important;
}

.padding_leftinpx {
  padding-left: 5px;
}

.overxflow_caseinfo {
  overflow-x: hidden !important;
}

.case_info_extra {
  max-height: 27vh !important;
  overflow-x: hidden !important;
}

.caseinfo_icd_codes {
  max-height: 8vh !important;
  overflow: hidden !important;
}

.caseinfo_insurance {
  max-height: 16vh;
  overflow-x: hidden;
}

.quality_atrributes_info {
  min-height: 20vh !important;
  overflow-x: hidden !important;
  width: 100% !important;
  max-height: 77vh !important;
}

.caseInfo_flags {
  min-height: 18vh !important;
  overflow-x: hidden !important;
  max-height: 76vh !important;
}

.gurantor_padding {
  padding-inline: 24px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/case360/caseinfo/caseinfo.component.scss"],"names":[],"mappings":"AACA;EACE,kCAAA;EACA,YAAA;AAAF;;AAEA;EACE,0BAAA;AACF;;AACA;EACE,kCAAA;AAEF;;AAAA;EACE,kCAAA;AAGF;;AAAA;EACE,UAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,8BAAA;AAGF;;AADA;EACE,cAAA;AAIF;;AAFA;EACE,UAAA;EACA,+GAAA;EACA,kBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,kBAAA;EACA,QAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;AAMF;;AAJA;EACE,eAAA;EACA,kBAAA;AAOF;;AALA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;AAQF;;AAJA;EACE,YAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;AAOF;;AALA;EACE,+CAAA;EACA,mBAAA;AAQF;;AAJE;EACE,YAAA;AAOJ;;AA4BA;EACE,aAAA;AAzBF;;AA2BQ;EACN,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAxBF;;AA0BA;EACE,aAAA;AAvBF;;AAyBQ;EACN,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AAtBF;;AAwBA;EACE,YAAA;EACA,+BAAA;AArBF;AAsBE;EACE,YAAA;EAAa,+CAAA;AAnBjB;AAoBM;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;AAlBR;AAmBA;EACE,kBAAA;EACA,QAAA;EACA,QAAA;AAjBF;AAmBA;EACE,UAAA;EACE,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;AAjBJ;AAsBE;EACE,uBAAA;EACA,kBAAA;EACA,yBAAA;AApBJ;AAsBE;;EAIE,6BAAA;AAtBJ;AAyBE;EACE,oCAAA;AAvBJ;AAyBE;EACE,oCAAA;EACA,sBAAA;AAvBJ;AAyBE;EACE,0BAAA;EACA,2BAAA;EACA,kCAAA;AAvBJ;AA0BE;EACI,yBAAA;EACA,kCAAA;EACA,yBAAA;AAxBN;AA0BQ;EACE,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AAxBV;AA0BgB;EACN,wBAAA;AAxBV;AA4BQ;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;AA1BV;AA4BgB;EACN,wBAAA;AA1BV;;AA+BA;EACE,YAAA;EACA,8BAAA;EACA,gBAAA;AA5BF;AA6BE;EACE,YAAA;EAAa,+CAAA;AA1BjB;;AA6BA;EACE,YAAA;EACA,mBAAA;EACA,oBAAA;AA1BF;;AA4BA;EACE,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gCAAA;AAzBF;;AA4BA;EACE,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gCAAA;AAzBF;;AAoCA;EACE,4BAAA;EACA,gCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AAjCF;;AAoCA;EACA,yBAAA;AAjCA;;AAoCA;EACE,oBAAA;EAAqB,gBAAA;EAAiB,kBAAA;EAAmB,gBAAA;AA9B3D;;AAkCA;EACI,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;AA/BJ;;AAmCA;EACE,WAAA;EACA,uBAAA;EACA,mBAAA;AAhCF;;AAoCE;EACE,uBAAA;EACA,4BAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;AAjCJ;;AAqCA;EACE,kBAAA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAlCJ;;AAsCA;EACE,yBAAA;EACA,0BAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAnCF;;AAqCA;EACE,kBAAA;AAlCF;;AAqCA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AAlCF;AAmCE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAjCJ;;AAoCA;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;AAjCF;AAkCE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gCAAA;AAhCJ;;AAoCA;EACE,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAjCF;;AAmCA;EACE,gCAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAhCF;;AAoCA;EACE,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AAjCF;;AAqCA;EACE,2BAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;AAlCF;;AAqCA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,cAAA;EACA,gBAAA;AAlCF;;AAsCA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;AAnCF;;AAqCA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAlCF;;AAqCA;EACE,cAAA;AAlCF;;AAoCA;EACE,YAAA;AAjCF;;AAmCA;EACE,YAAA;AAhCF;;AAmCA;EACE,YAAA;AAhCF;;AAkCA;EACE,YAAA;AA/BF;;AAiCA;EACE,YAAA;AA9BF;;AAgCA;EACE,YAAA;AA7BF;;AA+BA;EACC,gBAAA;EACC,mBAAA;AA5BF;;AA8BA;EACG,kBAAA;EACD,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACC,iBAAA;AA3BH;;AA6BA;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;AA1BF;;AA6BA;EACE,YAAA;AA1BF;;AA4BA;EACE,YAAA;AAzBF;;AA2BA;EACE,YAAA;AAxBF;;AA0BA;EACE,YAAA;AAvBF;;AAyBA;EACE,YAAA;AAtBF;;AAwBA;EAEI,eAAA;AAtBJ;;AA0BA;EAEI,cAAA;EACA,gBAAA;AAxBJ;;AA4BA;EACE,oCAAA;EACE,0BAAA;EACA,eAAA;AAzBJ;;AA6BA;EACE,yBAAA;AA1BF;;AA4BA;EACE,yBAAA;AAzBF;;AA2BA;EACE,yBAAA;AAxBF;;AA0BA;EACE,yBAAA;AAvBF;;AAyBA;EACE,yBAAA;AAtBF;;AAwBA;EACE,yBAAA;AArBF;;AAuBA;EACE,yBAAA;AApBF;;AAwBA;EACE,cAAA;AArBF;;AAwBA;EACkB,uBAAA;EACA,mBAAA;EACA,kBAAA;AArBlB;;AAyBA;EAEE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAvBF;;AA4BA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,cAAA;AAzBF;;AA6BA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AA1BF;;AA8BA;EACE,iBAAA;AA3BF;;AA+BA;EACE,6BAAA;AA5BF;;AA+BA;EACE,2BAAA;EAA2B,6BAAA;AA3B7B;;AA8BA;EACE,0BAAA;EACA,2BAAA;AA3BF;;AA6BA;EACE,gBAAA;EACA,kBAAA;AA1BF;;AA6BA;EACE,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,2BAAA;AA1BF;;AA6BA;EACE,2BAAA;EACA,6BAAA;EACA,2BAAA;AA1BF;;AA6BA;EACE,+BAAA;AA1BF","sourcesContent":["@import '../../../variables.scss'  ;\r\n.caseinfo{\r\n  font-family: montserrat !important;\r\n  height: 73vh;\r\n}\r\n.Case_360_view{\r\n  font-size: 12px !important;\r\n}\r\n.insurance_detials{\r\n  font-family:montserrat !important;\r\n}\r\n.quality_attribute{\r\n  font-family:montserrat !important;\r\n}\r\n\r\n.eventselecttypeControl{\r\n  width: 96%;\r\n  border: none;\r\n  padding-block: 2px;\r\n  height: 28px;\r\n  margin-left: 2%;\r\n  padding-right: 23px !important;\r\n}\r\n.blod_text{\r\n  color: #007887;\r\n}\r\n.date_control_style {\r\n  width: 30%;\r\n  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 2px 1px -1px rgb(0 0 0 / 12%);\r\n  border-radius: 5px;\r\n  padding-inline: 2%;\r\n}\r\n.close_icon{\r\n  position: absolute;\r\n  top: 27%;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  color: grey;\r\n  font-weight: 600;\r\n  right: 0;\r\n}\r\n.help-main-title{\r\n  font-size:17px;\r\n  text-align: center;\r\n}\r\n.case_details{\r\n  flex: auto;\r\n  text-align: center;\r\n  position: relative;\r\n//   width: 14.28%;\r\n// float: left;\r\n}\r\n.caseHeaderBorder{\r\n  height: 14px;\r\n  width: 2px;\r\n  background-color: #376b96 !important;\r\n  position: absolute;\r\n  top: 14%;\r\n  right: 0%;\r\n}\r\n.case_info{\r\n  background: #c1bdbd 0% 0% no-repeat padding-box;\r\n  padding-inline: 8px;\r\n  // border-radius: 5px;\r\n}\r\n::ng-deep.case_tabs{\r\n  .mat-tab-header{\r\n    height: 33px;\r\n  }\r\n  // .mat-tab-label {\r\n  //   height: 31px !important;\r\n  //   text-transform: uppercase;\r\n  // }\r\n  // .mat-tab-group.mat-primary .mat-ink-bar,\r\n  // .mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n  //   // background-color: #f77a99 !important;\r\n  //   // left: 12px !important;\r\n  //   margin-left: unset !important;\r\n  // }\r\n\r\n  // .mat-tab-label-container{\r\n  //   background-color: transparent;\r\n  //   border-bottom: 1px solid #17a0b4;\r\n  // }\r\n  // .mat-tab-group.mat-primary .mat-ink-bar{\r\n  //   background-color: #17a0b4 !important;\r\n  //   height: 2px !important;\r\n  // }\r\n  // .mat-tab-label .mat-tab-label-content{\r\n  //   font-size: 11px !important;\r\n  //   font-weight: 600 !important;\r\n  //     font-family: montserrat !important;\r\n  // }\r\n\r\n  // .mat-tab-label.mat-ripple.mat-tab-label-active{\r\n  //     color:  #17a0b4 !important;\r\n  //     background-color: white !important;\r\n  //     opacity: unset !important;\r\n\r\n  //   }\r\n}\r\n\r\n.active_img{\r\n  display: none;\r\n        }\r\n        .inactive_img{\r\n  display: block;\r\n  margin-right: 9px;\r\n  position: relative;\r\n  top: -2px;\r\n        }\r\n.active_img_inbound{\r\n  display: none;\r\n        }\r\n        .inactive_img_inbound{\r\n  display: block;\r\n  margin-right: 11px;\r\n  position: relative;\r\n  top: -2px;\r\n        }\r\n::ng-deep.event_card{\r\n  height: 75vh;\r\n  border-right: 3px solid #007887;\r\n  .header{\r\n    height: 50px;background: #F2F2F2 0% 0% no-repeat padding-box;\r\n      .search_control{\r\n        width: 90%;\r\n        height: 28px;\r\n        margin: auto;\r\n        border-radius: 5px;\r\n        border: 1px solid #001C3B;\r\n        background-color: white;\r\n.search_icon{\r\n  position: relative;\r\n  left: 2%;\r\n  top: 10%;\r\n}\r\n.input_control{\r\n  width: 93%;\r\n    border: none;\r\n    background-color: transparent;\r\n    position: relative;\r\n    left: 3%;\r\n    top: 13%;\r\n}\r\n      }\r\n  }\r\n\r\n  .mat-tab-label {\r\n    height: 37px !important;\r\n    flex: 1 !important;\r\n    text-transform: uppercase;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar,\r\n  .mat-tab-nav-bar.mat-primary .mat-ink-bar {\r\n    // background-color: #f77a99 !important;\r\n    // left: 12px !important;\r\n    margin-left: unset !important;\r\n  }\r\n\r\n  .mat-tab-label-container{\r\n    background-color: #F3F3F3 !important;\r\n  }\r\n  .mat-tab-group.mat-primary .mat-ink-bar{\r\n    background-color: #17a0b4 !important;\r\n    height: 3px !important;\r\n  }\r\n  .mat-tab-label .mat-tab-label-content{\r\n    font-size: 12px !important;\r\n    font-weight: 600 !important;\r\n    font-family: montserrat !important;\r\n  }\r\n\r\n  .mat-tab-label.mat-ripple.mat-tab-label-active{\r\n      color:  #17a0b4 !important;\r\n      background-color: white !important;\r\n      opacity: unset !important;\r\n      .outbound_style{\r\n        .active_img{\r\n          display: block !important;\r\n          margin-right: 9px;\r\n          position: relative;\r\n          top: -2px;\r\n                }\r\n                .inactive_img{\r\n          display: none !important;\r\n                }\r\n      }\r\n      .inbound_style{\r\n        .active_img_inbound{\r\n          display: block !important;\r\n          margin-right: 11px;\r\n          position: relative;\r\n          top: -2px;\r\n                }\r\n                .inactive_img_inbound{\r\n          display: none !important;\r\n                }\r\n      }\r\n    }\r\n}\r\n.event_card_info{\r\n  height: 75vh;\r\n  border-left: 3px solid #007887;\r\n  margin-left: 2px;\r\n  .header{\r\n    height: 50px;background: #F2F2F2 0% 0% no-repeat padding-box;\r\n  }\r\n}\r\n.Event_lables{\r\n  height: 60px;\r\n  background: #E5F1F3;\r\n  padding-inline: 13px;\r\n}\r\n.eventtype_lables{\r\n  background-color: white;\r\n  padding-inline: 4%;\r\n  padding-block: 0px;\r\n  margin: 8px;\r\n  display: inline-block;\r\n  border-radius: 50pc;\r\n  cursor: pointer;\r\n  box-shadow: 1px 1px 4px 0px grey;\r\n}\r\n\r\n.eventtype_lables_active{\r\n  background-color: #007887;\r\n  padding-inline: 4%;\r\n  padding-block: 0px;\r\n  margin: 8px;\r\n  display: inline-block;\r\n  border-radius: 50pc;\r\n  cursor: pointer;\r\n  color: white;\r\n  box-shadow: 1px 1px 4px 0px grey;\r\n}\r\n// @font-face {\r\n//   font-family: 'inoubd';\r\n//   src: url('a1xex-u3e2x.ttf');\r\n// }\r\n\r\n// .usefont{\r\n//   font-family: 'inoubd', sans-serif;\r\n// }\r\n\r\n.messageInfo{\r\n  border-left: 4px solid green;\r\n  box-shadow: 1px 1px 6px 0px grey;\r\n  border-radius: 5px;\r\n  padding-inline: 6px;\r\n  padding-block: 3px;\r\n}\r\n\r\n.cardActive{\r\nbackground-color: #CCE4E7;\r\n}\r\n\r\n.listview{\r\n  padding-inline: 19px;max-height: 53vh;overflow-x: hidden;overflow-y: auto;\r\n}\r\n\r\n\r\n.view_file_icon{\r\n    width: 19px !important;\r\n    float: left;\r\n    position: relative;\r\n    top: -3px;\r\n    left: 6px;\r\n}\r\n\r\n\r\n.barline{\r\n  height: 1px;\r\n  background-color: black;\r\n  margin-inline: 13px;\r\n}\r\n\r\n::ng-deep.message_menu.mat-menu-panel{\r\n  button.mat-menu-item{\r\n    height: 26px !important;\r\n    line-height: 26px !important;\r\n    text-align: center !important;\r\n    color: #179fb3 !important;\r\n    font-size: 13px !important;\r\n  }\r\n}\r\n\r\n.lables_status{\r\n  border-radius: 4px;\r\n    padding-block: 3px;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n}\r\n\r\n\r\n::ng-deep.viewstages .modal-dialog {\r\n  max-width: 97% !important;\r\n  max-height: 60% !important;\r\n  height: 60% !important;\r\n  margin: auto !important;\r\n  padding: 0 !important;\r\n}\r\n::ng-deep.viewstages {\r\n  top: 4% !important;\r\n}\r\n\r\n.inputContainer{\r\n  height: 81vh;\r\n  background-color: #F3F3F3;\r\n  border: 1px solid #707070;\r\n  .header{\r\n    background-color: #D1D1D1;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-bottom: 1px solid #707070;\r\n  }\r\n}\r\n.outputContainer{\r\n  height: 81vh;\r\n  background-color: #F3F3F3;\r\n  border: 1px solid #707070;\r\n  .header{\r\n    background-color: #D1D1D1;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    border-bottom: 1px solid #707070;\r\n  }\r\n}\r\n\r\n.icons_list_style{\r\n  width: 5%;\r\n  padding-bottom: 8px;\r\n  text-align: center;\r\n  margin-inline: 3px;\r\n}\r\n.icons_list_style_active{\r\n  border-bottom: 3px solid #00BCD4;\r\n  width: 5%;\r\n  padding-bottom: 8px;\r\n  text-align: center;\r\n  margin-inline: 3px;\r\n}\r\n\r\n\r\n.case_info_container{\r\n  border: 1.5px solid #001C3B;\r\n  padding: 5px;\r\n  position: relative;\r\n  margin-block: 16px;\r\n\r\n}\r\n\r\n.sign_out_details{\r\n  border: 1.5px solid #001C3B;\r\n  padding: 5px;\r\n  position: relative;\r\n  margin-block: 16px;\r\n  height: 44vh;\r\n}\r\n\r\n.card_label_title{\r\n  background-color: #fbfbfb;\r\n  position: absolute;\r\n  padding-inline: 5px;\r\n  font-size: 10px;\r\n  top: -9px;\r\n  color: #001C3B;\r\n  font-weight: 600;\r\n}\r\n\r\n\r\n.lables_style{\r\n  font-size: 10px;\r\n  color: #001C3B;\r\n  font-weight: 600;\r\n}\r\n.value_style{\r\n  font-weight: 600;\r\n  font-size: 10px;\r\n  color:#5682A6 !important;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.case_details_info{\r\n  height: 16.5vh;\r\n}\r\n.dates_info{\r\n  height: 22vh;\r\n}\r\n.case_info_data{\r\n  height: 28vh;\r\n}\r\n\r\n.case_patient_info{\r\n  height: 35vh;\r\n}\r\n.case_Information_info{\r\n  height: 29vh;\r\n}\r\n.case_Contact_info{\r\n  height: 29vh;\r\n}\r\n.case_Insurance_info{\r\n  height: 17vh;\r\n}\r\n.case_DX_reports{\r\n min-height: 12vh;\r\n  margin-bottom: 20px;\r\n}\r\n.report-name {\r\n   margin-right: 30px;\r\n  max-width: 125px;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  cursor: pointer;\r\n   font-weight: bold;\r\n}\r\n.report_status {\r\n  white-space: normal;\r\n  overflow: visible;\r\n  word-break: normal;\r\n \r\n}\r\n.case_send_in_details{\r\n  height: 12vh;\r\n}\r\n.case_referring_details{\r\n  height: 14vh;\r\n}\r\n.case_laboratory_details{\r\n  height: 20vh;\r\n}\r\n.case_orderingfacility_details{\r\n  height: 17vh;\r\n}\r\n.case_send_out_details{\r\n  height: 11vh;\r\n}\r\n.sec_date{\r\n\r\n    font-size: 10px;\r\n\r\n\r\n}\r\n.pt_date{\r\n\r\n    font-size: 9px;\r\n    margin-left: 3px;\r\n\r\n}\r\n\r\n.more_info{\r\n  color:#0000ffa6;\r\n    text-decoration: underline;\r\n    cursor: pointer;\r\n}\r\n\r\n\r\n.orderedDate{\r\n  color: #827EC4 !important;\r\n}\r\n.collectionDate{\r\n  color: #80A8D0 !important;\r\n}\r\n.receivedDate{\r\n  color: #278C7D !important;\r\n}\r\n.signedoutDate{\r\n  color: #D17800 !important;\r\n}\r\n.reportDate{\r\n  color: #C02755 !important;\r\n}\r\n.sendinDate{\r\n  color: #443EA7 !important;\r\n}\r\n.sendoutDate{\r\n  color: #3575B5 !important;\r\n}\r\n\r\n\r\n.insurance_more_info{\r\n  height: 59.5vh;\r\n}\r\n\r\n.text_elip{\r\n                  text-overflow: ellipsis;\r\n                  white-space: nowrap;\r\n                  overflow-x: hidden;\r\n}\r\n\r\n\r\n.flag_class{\r\n\r\n  background-color: #E8E8E5;\r\n  border-radius: 3px;\r\n  color: #001C3B;\r\n  font-size: 11px;\r\n  min-width: 164px !important;\r\n  padding-inline: 9px;\r\n  margin-inline: 3px;\r\n  max-width: 320px;\r\n  height: 23px;\r\n  display: inline-block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow-x: hidden;\r\n  padding-block: 3px;\r\n\r\n}\r\n\r\n\r\n.no_data{\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  color: #17a0b4;\r\n}\r\n\r\n\r\n.myCustomModalViewfile .modal-dialog {\r\n  max-width: 80%;\r\n  max-height: 60%;\r\n  height: 60%;\r\n  margin: auto;\r\n  padding: 0 !important;\r\n}\r\n\r\n\r\n.padding_leftinpx{\r\n  padding-left: 5px;\r\n}\r\n\r\n\r\n.overxflow_caseinfo{\r\n  overflow-x: hidden !important;\r\n}\r\n\r\n.case_info_extra{\r\n  max-height:27vh !important;overflow-x: hidden !important;\r\n}\r\n\r\n.caseinfo_icd_codes{\r\n  max-height: 8vh !important;\r\n  overflow: hidden !important;\r\n}\r\n.caseinfo_insurance{\r\n  max-height: 16vh;\r\n  overflow-x: hidden;\r\n}\r\n\r\n.quality_atrributes_info{\r\n  min-height: 20vh !important;\r\n  overflow-x: hidden !important;\r\n  width: 100% !important;\r\n  max-height: 77vh !important;\r\n}\r\n\r\n.caseInfo_flags{\r\n  min-height: 18vh !important;\r\n  overflow-x: hidden !important;\r\n  max-height: 76vh !important;\r\n}\r\n\r\n.gurantor_padding{\r\n  padding-inline: 24px !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
